import Area from '@/components/Area';
import { GizmoHelper, GizmoViewport, Html, Text } from '@react-three/drei';
import { Canvas, useFrame, useThree } from '@react-three/fiber';
import * as React from 'react';
import * as THREE from 'three';

function Box(props: React.ComponentProps<'mesh'> & { text: React.ReactNode; color: string }) {
  const { text, color, ...rest } = props;
  const [hovered, setHovered] = React.useState(false);
  return (
    <mesh onPointerOver={() => setHovered(true)} onPointerOut={() => setHovered(false)} {...rest}>
      <boxGeometry args={[2, 2, 2]} />
      <meshStandardMaterial color={hovered ? 'hotpink' : color} />
      <Html position={[0, 0, 1]} center css={{ pointerEvents: 'none' }}>
        {text}
      </Html>
    </mesh>
  );
}

function Scene() {
  const viewport = useThree((state) => state.viewport);
  return (
    <>
      <Box text={<span>This is HTML</span>} color="aquamarine" />
      <Box text={<h1>H1 caption</h1>} color="lightblue" position={[0, -viewport.height, 0]} />
    </>
  );
}

function ScrollContainer({
  refScrollOffset,
  children,
}: React.PropsWithChildren<{ refScrollOffset: React.MutableRefObject<number> }>) {
  const viewport = useThree((state) => state.viewport);
  const refGroup = React.useRef<THREE.Group>(null);
  useFrame(() => {
    const group = refGroup.current;
    if (group) {
      group.position.y = viewport.height * refScrollOffset.current;
    }
  });
  return <group ref={refGroup}>{children}</group>;
}

function ScrollTextDebug({
  refScrollOffset,
  ...rest
}: Omit<React.ComponentProps<typeof Text>, 'children'> & { refScrollOffset: React.MutableRefObject<number> }) {
  const refText = React.useRef<any>(null);
  useFrame(() => {
    const text = refText.current;
    if (text) {
      text.text = refScrollOffset.current.toFixed(2);
    }
  });
  return (
    <Text ref={refText} {...rest}>
      -
    </Text>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;
  const refScroll = React.useRef<HTMLDivElement>(null);
  const refScrollOffset = React.useRef(0);
  return (
    <Area css={{ position: 'relative', overflow: 'hidden' }}>
      {(elParent) => (
        <>
          <Canvas eventSource={elParent} eventPrefix="client">
            <ambientLight />
            <pointLight position={[10, 0, 10]} />
            <ScrollContainer refScrollOffset={refScrollOffset}>
              <Scene />
            </ScrollContainer>
            <ScrollTextDebug refScrollOffset={refScrollOffset} position={[4, 0, 0]} scale={2} />
            <gridHelper args={[10, 10]} rotation={[Math.PI / 2, 0, 0]} />
            {/* <OrbitControls /> */}
            <axesHelper args={[5]} />
            <GizmoHelper alignment="bottom-left" margin={[80, 80]}>
              <GizmoViewport></GizmoViewport>
            </GizmoHelper>
          </Canvas>
          <div
            ref={refScroll}
            css={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', overflowY: 'scroll' }}
            onScroll={(e) => {
              const target = e.target as HTMLDivElement;
              refScrollOffset.current = target.scrollTop / (target.scrollHeight - target.clientHeight);
            }}
          >
            <div css={{ height: elParent.clientHeight * 2, pointerEvents: 'none' }}></div>
          </div>
        </>
      )}
    </Area>
  );
}

export default React.memo(App01);
